import ServiceDetailPage from "@/components/ServiceDetailPage";

const Activity = () => <ServiceDetailPage pageKey="activity" />;

export default Activity;
